export const AdTypes = {
  rent: 'Сдать',
  sell: 'Продать',
} as const;

export const safeTags: string[] = [
  'b',
  'em',
  'div',
  'pre',
  'sub',
  'sup',
  'strong',
  'br',
  'hr',
];

export const contactPhones = [
  '8-800-707-34-90', '8-3537-28-77-11',
];
